import { isStatusCodeError } from './isStatusCodeError';

export const isTooManyRequestsError = (error: Parameters<typeof isStatusCodeError>[0]): boolean =>
	isStatusCodeError(error, '429');
